const DefinedConstant = [
  { name: 'pi', value: '3.14159' },
  { name: 'e', value: '2.71828' },
  { name: 'year', value: '2017' },
  { name: 'currency1', value: '4.0' },
  { name: 'currency2', value: '0.8' },
]

export default DefinedConstant